import {
  Box,
  Center,
  useColorModeValue,
  Heading,
  Text,
  Stack,
  Image,
} from "@chakra-ui/react";

const IMAGE =
  "https://images.livemint.com/img/2020/07/14/600x338/PTI13-07-2020_000168B_1594694537154_1594694556277.jpg";

export default function StudentDetails({ image, name, marks, details }) {
  return (
    <Center  w={{ base: "100%", md: "90%" }} m={"auto"} py={5} mt={"50px"}>
      <Box
        h={"600px"}
        overflow={"hidden"}
        role={"group"}
        p={6}
        maxW={"330px"}
        w={"full"}
        bg={useColorModeValue("white", "gray.800")}
        boxShadow={"2xl"}
        rounded={"lg"}
        pos={"relative"}
        zIndex={1}
      >
        <Box
          rounded={"lg"}
          mt={-12}
          pos={"relative"}
          height={"230px"}
          top={7}
          _after={{
            transition: "all .3s ease",
            content: '""',
            w: "full",
            h: "full",
            pos: "absolute",
            top: 5,
            left: 0,
            backgroundImage: `url(${IMAGE})`,
            filter: "blur(15px)",
            zIndex: -1,
          }}
          _groupHover={{
            _after: {
              filter: "blur(20px)",
            },
          }}
        >
          <Image
            rounded={"lg"}
            height={230}
            width={282}
            objectFit={"cover"}
            src={image}
          />
        </Box>
        <Stack pt={10} align={"center"}>
          <Heading
            color={"gray.500"}
            fontSize={"2xl"}
            textTransform={"uppercase"}
          >
            {name}
          </Heading>
          <Heading
            fontSize={{ base: "md", md: "xl" }}
            fontFamily={"body"}
            fontWeight={500}
            marginBottom="4px"
          >
            {marks ? (
              <>Marks - {marks}</>
            ) : (
              <span style={{ fontFamily: "Arvo" }}>Jee Mains Ranker</span>
            )}
          </Heading>
          {/* <Heading fontSize={'xl'} fontFamily={'body'} fontWeight={500}>
            {marks}
          </Heading> */}
          <Stack direction={"row"} align={"center"}>
            <Text textDecoration={"none"} color={"gray.600"}>
              {details}
            </Text>
          </Stack>
        </Stack>
      </Box>
    </Center>
  );
}
